import React, { useMemo, useState } from "react";
import { Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";
// import { EditIcon } from "./";
// import { PrintIcon } from "./constant";
import { FiBell } from "react-icons/fi";
import ALoader from "views/pages/manage/common/a-loader";
// import { FeeIcon } from "../../assets/img/svg/MoneyWavy.svg";
import { PrintIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";
import NotificationDialog from "./SendNotification";
import { fetchCertificateDetails, getUploadCertificateS3Key, sendNotificationFn, useNotificationLogic } from "./utils";
import { useFetchAdjustmentInSummary } from "../../modules/studentTransfer/customHooks";
import { useFetchTransferInSummary } from "modules/studentTransfer/customHooks";
import { formatTransferInItems, formatTransferOutTax } from "modules/studentTransfer/components/utils";
import AdjustmentDetailsModal from "modules/studentTransfer/components/verifyPayments/viewSummaryDetails/AdjustmentDetailsModal";
import { useModal } from "contexts/customModal";
import { useGetPermissions } from "layouts/customHook";
import { printReceipt } from "./utils";
import { endpoint } from "../../views/pages/manage/common/constant";
import { getCreateReceiptTemplateData } from "./constant";
import { FeeIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";

const ViewActions = ({
  steps,
  isListing = false,
  details,
  psid,
}) => {


  const [loader, setLoader] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const { showModal } = useModal();

  const notificationHandler = () => {
    setIsNotifOpen(true);
  };


  const buildPayload = ({ selectedModes, details, studentInfo, s3Key }) => ({
    notificationChannel: selectedModes,
    s3Key,
    details
  });

  const logicHook = useNotificationLogic({
    details,
    certificatePayloadData: { psId: psid, outApplicationId: details?.transferOutAppId, outCourseId: details?.outCourseId?.[0], outTermValue:details?. outTerm?.[0], outBusinessAreaValue: details?.outBusinessArea, inBusinessAreaValue: details?.inBusinessArea },
    templateName: 'transferCertificate',
    dataEndpoint: endpoint.studentTransfer.getTransferCertificateDetails,
    extraInfoForCertificate: { transferType: details?.transferType, transferReason: details?.transferReason },
    getTransferCertificateDetails: getCreateReceiptTemplateData,
    fetchCertificateDetails: fetchCertificateDetails,
    sendNotificationFn: sendNotificationFn,
    getUploadCertificateS3Key: getUploadCertificateS3Key,
    buildFinalPayloadFn: buildPayload,
    onSuccess: (res) => console.log("Success sent:", res),
  });
  const { rows, loading, tInBalanceAmount } = useFetchTransferInSummary(
    details?.appId,
    details?.outBusinessArea
  );

  const memoizedTransferIn = useMemo(() => details, [details]);
  const memoizedTransferOut = useMemo(() => details, [details]);

  const { summary: adjustmentData, loading: adjustmentLoading } = useFetchAdjustmentInSummary(
    memoizedTransferIn,
    memoizedTransferOut
  );

  const groupedData = useMemo(
    () => ({
      TRANSFER_OUT: formatTransferOutTax(rows),
      TRANSFER_IN: formatTransferInItems(adjustmentData?.itemTypeDetails, rows),
    }),
    [adjustmentData, rows]
  );
 

  const printCertificateHandler = async () => {
    const { transferOutAppId,transferInAppId, transferType, transferReason, outCourseId, outTerm, outBusinessArea, inBusinessArea } = details;

    const data = {
      payloadData: { psId: psid, inApplicationId: transferInAppId, outCourseId: outCourseId?.[0], outTermValue: outTerm?.[0], outBusinessAreaValue: outBusinessArea, inBusinessAreaValue: inBusinessArea },
      templateName: 'transferCertificate',
      dataEndpoint: endpoint.studentTransfer.getTransferCertificateDetails,
      transferType,
      transferReason
    };
    setLoader(true);
    await printReceipt(data);
    setLoader(false);
  };

  const actionDisable=!(Array.isArray(steps)&& steps?.[steps.length-1]?.title=="Transfer processed"&&steps?.[steps.length-1]?.status=='completed')
    const noActionEnableColor = actionDisable
    ? "#B7B7B7"
    : "#0F0F0F";
  return (
    <>
    {loader&&<ALoader position='fixed'/>}
      {!isListing && (
        <Card style={{ width: "inherit%", height: "256px", marginLeft: "24px" }}>
          <CardBody>
            <div className="dark-text label-color">Actions</div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={() => {
               !actionDisable&& printCertificateHandler()
              }}
            //   onClick={!actionDisable?.noActionEnable && printReceiptHandler}
            >
              <PrintIcon color={noActionEnableColor} />
              <span style={{ color: `${noActionEnableColor}` }}>
                Print Transfer Certificate
              </span>
            </div>


            <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}

              onClick={!actionDisable && notificationHandler}
            >
              <FiBell
                style={{
                  width: "22px",
                  height: "26px",
                  color: `${noActionEnableColor}`,
                }}
              />
              <span
               style={{ color: `${noActionEnableColor}` }}
              >
                Send Notification
              </span>
            </div>
            <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={() =>
               !actionDisable && showModal({
                  title: `View detailed adjustments (App. ID ${details?.appId})`,
                  content: (
                    <AdjustmentDetailsModal
                      groupedData={groupedData}
                      applicationId={details?.appId}
                      transferInBU={details?.inBusinessArea}
                      transferOutBU={details?.outBusinessArea}
                    />
                  ),
                  maxWidth: "lg",
                })
              }
            >
              <FeeIcon
                color={noActionEnableColor}
              />
              <span
               style={{ color: `${noActionEnableColor}` }}
              >
                Calculate Fees
              </span>
            </div>
          </CardBody>
        </Card>
      )}

      <NotificationDialog
        open={isNotifOpen}
        handleCloseDialog={() => setIsNotifOpen(false)}
        details={details}
        logicHook={logicHook}

      />
    </>
  );
};

export default ViewActions;
